module.exports = __webpack_public_path__ + "static/7-739695f38aecce500f2e063391195124.jpeg";